import { render, staticRenderFns } from "./EditorPopup.vue?vue&type=template&id=13a06f29&scoped=true"
var script = {}
import style0 from "./EditorPopup.vue?vue&type=style&index=0&id=13a06f29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a06f29",
  null
  
)

export default component.exports